var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-menu',{attrs:{"mode":"inline","selectedKeys":[_vm.$route.path]},on:{"click":_vm.handleClick}},_vm._l((_vm.menuList),function(item){return _c('a-menu-item',{key:'/'+item.path.split('/')[2]},[_vm._v(" "+_vm._s(item.title)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }